import { IDncByTeam } from 'wisestep-api';
import { timeSince, getFormatDate } from 'wisestep-base';

export const getDncMessage = (dncByTeam: IDncByTeam, name: string) => {
  let dncMessage = '';
  if (!dncByTeam?.dataPrivacyOption) {
    dncMessage = `This candidate is in <b>Forget List</b>`;
  } else if (dncByTeam?.dataPrivacyOption === 'delete') {
    if (dncByTeam?.isDeleted || dncByTeam?.deleteRequestAcceptedBy) {
      dncMessage = `This candidate data has been deleted by 
      ${dncByTeam?.deleteRequestAcceptedBy} ${timeSince(String(dncByTeam?.acceptedOn))}`;
    } else {
      dncMessage = 'This candidate has been queued up to be deleted';
    }
  } else {
    dncMessage = `This candidate is in <b>${dncByTeam?.dataPrivacyOption.toUpperCase()}</b> List ${
      dncByTeam.dataPrivacyOption === 'restrict'
        ? `up to <b>${getFormatDate(String(dncByTeam?.dncEndDate))}</b> `
        : ''
    }${
      dncByTeam?.isAddedByCandidate
        ? `(on request by candidate) ${name}`
        : `modified by ${name} <b>${timeSince(String(dncByTeam?.modifiedOn))}</b>`
    }`;
  }
  return dncMessage;
};
